<template>
    <div class="topic">
        <h1 class="pageHeading">
            What Are Your Interests?
        </h1>
        <p>Select as many topics as you'd like</p>
        <div class="containerBox">
            <bs-input label="Search Topics" type="text" id="topic_search" placeholder="Search Topics">
        <span slot="after" class="input-group-addon inputIcon">
          <span class="glyphicon glyphicon-search"></span>
        </span>
            </bs-input>
            <button-group v-model="interestIndexes">
                <checkbox class="min-padding" v-for="(interest, index) in interests" :key="index" :true-value="index">
                    {{interest.interestName}}
                </checkbox>
            </button-group>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                <button class="btn formButton" @click="proceedUserInfo()">
                    Done
                    <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { buttonGroup } from 'vue-strap'
import spinner from '@/accessibility/Spinner'
import input from '@/accessibility/Input'
import checkbox from '@/accessibility/Checkbox'
import { mapGetters } from 'vuex'
export default {
    components: {
        'bs-input': input,
        'spinner': spinner,
        'checkbox': checkbox,
        'button-group': buttonGroup
    },
    name: 'topic',
    data: function () {
        this.$store.dispatch('INTEREST').then(() => {
            console.log('interest request data')
        })
        return {
            interestIndexes: [],
            spinner: false
        }
    },
    computed: {
        ...mapGetters([
            'interests'
        ])
    },
    methods: {
        spinnerToggle () {
            this.spinner = !this.spinner
        },
        filteredInterest (interestIndexes) {
            let vm = this
            let selectedInterest = []
            for (var i = 0; i < interestIndexes.length; i++) {
                selectedInterest.push(vm.interests[interestIndexes[i]])
            }
            return selectedInterest
        },
        proceedUserInfo () {
            let vm = this
            if (vm.interestIndexes.length) {
                vm.spinnerToggle()
                setTimeout(function () {
                    vm.$store.dispatch('SIGNUP', {interest: vm.filteredInterest(vm.interestIndexes)}).then(() => {
                        vm.spinnerToggle()
                    })
                }, 1000)
            }
        }
    }
}
</script>

<style scoped>
    .topic{
        width: 40%;
        margin: 0 auto;
    }
    .topic .inputIcon{
        border: none;
        background: #f6f6f6;
    }
    .topic .pageHeading{
        font-size: 32px;
        color: #009cf6;
        font-weight: lighter;
        margin: 0 0 25px 0;
    }
    .topic p{
        font-size: 14px;
        color: #979797;
        margin: 0;
    }
    .topic .containerBox{
        margin-top: 50px;
    }
    .topic .tagsContainer{
        margin: 25px 0;
    }
    .topic .tag{
        padding: 6px 12px;
        background: transparent;
        border: 1px solid #c6c6c6;
        border-radius: 5px;
        margin: 5px;
    }
    .formButton{
        margin: 25px 0 50px;
        width: 130px;
        height: 47px;
        color: #91ab45;
        border-color: #91ab45;
        background-color: transparent;
        transition: 0.5s;
        padding:0;
    }
    .formButton a{
        display: block;
        padding: 13px 12px;
        color: #91ab45;
        text-decoration: none;
        transition: 0.5s;
    }
    .formButton:hover{
        border-color: #91ab45;
        background-color: #91ab45;
        transition: 0.5s;
    }
    .formButton:hover a{
        color: #ffffff;
    }
    .min-padding {
        margin: 0.5em;
    }
</style>



// WEBPACK FOOTER //
// Topic.vue?04bf6622